/** Dashboard Mock数据 */

import type { DashboardStats, TrendPoint, RouteStat, Order, IoTAlert } from '../types';
import { OrderStatus, OrderDisplayStatus, AlertSeverity, AlertType } from '../types';
import { randomFloat } from '../utils/mockHelper';

const trendPoints: TrendPoint[] = [
  { date: '06-01', orders: 32, revenue: 128000 },
  { date: '06-02', orders: 28, revenue: 112000 },
  { date: '06-03', orders: 35, revenue: 145000 },
  { date: '06-04', orders: 30, revenue: 120000 },
  { date: '06-05', orders: 42, revenue: 168000 },
  { date: '06-06', orders: 38, revenue: 152000 },
  { date: '06-07', orders: 45, revenue: 180000 },
  { date: '06-08', orders: 33, revenue: 132000 },
  { date: '06-09', orders: 40, revenue: 160000 },
  { date: '06-10', orders: 48, revenue: 195000 },
  { date: '06-11', orders: 36, revenue: 144000 },
  { date: '06-12', orders: 50, revenue: 210000 },
  { date: '06-13', orders: 44, revenue: 176000 },
  { date: '06-14', orders: 52, revenue: 218000 },
];

const routeStats: RouteStat[] = [
  { route: '青岛 → 迪拜', count: 45, percentage: 0.28 },
  { route: '深圳 → 鹿特丹', count: 38, percentage: 0.24 },
  { route: '宁波 → 汉堡', count: 30, percentage: 0.19 },
  { route: '青岛 → 新加坡', count: 22, percentage: 0.14 },
  { route: '广州 → 迪拜', count: 15, percentage: 0.09 },
  { route: '厦门 → 釜山', count: 10, percentage: 0.06 },
];

const alertTimeline: IoTAlert[] = [
  {
    id: 'ALT001', deviceId: 'DEV001', containerId: 'CONT001',
    type: AlertType.TEMP_OUT_OF_RANGE, severity: AlertSeverity.WARNING,
    message: '温度超过阈值：当前 4.8°C，阈值 0-4°C',
    reading: { timestamp: '2025-07-02T08:30:00Z', temperature: 4.8, humidity: 65, co2: 420, shock: 0.1, lightExposure: 5 },
    acknowledged: true, acknowledgedBy: '张伟', createdAt: '2025-07-02T08:30:00Z', resolvedAt: '2025-07-02T09:15:00Z',
  },
  {
    id: 'ALT002', deviceId: 'DEV003', containerId: 'CONT003',
    type: AlertType.SHOCK_DETECTED, severity: AlertSeverity.CRITICAL,
    message: '检测到剧烈震动：加速度 8.5g',
    reading: { timestamp: '2025-07-02T06:45:00Z', temperature: 2.5, humidity: 60, co2: 400, shock: 8.5, lightExposure: 3 },
    acknowledged: false, acknowledgedBy: '', createdAt: '2025-07-02T06:45:00Z', resolvedAt: '',
  },
  {
    id: 'ALT003', deviceId: 'DEV005', containerId: 'CONT005',
    type: AlertType.DEVICE_OFFLINE, severity: AlertSeverity.WARNING,
    message: '设备离线超过30分钟',
    reading: { timestamp: '2025-07-02T04:00:00Z', temperature: 3.1, humidity: 58, co2: 410, shock: 0.2, lightExposure: 4 },
    acknowledged: true, acknowledgedBy: '李强', createdAt: '2025-07-02T04:00:00Z', resolvedAt: '2025-07-02T04:45:00Z',
  },
  {
    id: 'ALT004', deviceId: 'DEV002', containerId: 'CONT002',
    type: AlertType.HUMIDITY_OUT_OF_RANGE, severity: AlertSeverity.INFO,
    message: '湿度偏高：当前 78%，阈值 50-70%',
    reading: { timestamp: '2025-07-02T02:15:00Z', temperature: 3.2, humidity: 78, co2: 430, shock: 0.1, lightExposure: 6 },
    acknowledged: true, acknowledgedBy: '王芳', createdAt: '2025-07-02T02:15:00Z', resolvedAt: '2025-07-02T03:30:00Z',
  },
  {
    id: 'ALT005', deviceId: 'DEV007', containerId: 'CONT007',
    type: AlertType.LOW_BATTERY, severity: AlertSeverity.INFO,
    message: '设备电量低于10%，当前 8%',
    reading: { timestamp: '2025-07-01T22:00:00Z', temperature: 3.5, humidity: 62, co2: 400, shock: 0.1, lightExposure: 2 },
    acknowledged: false, acknowledgedBy: '', createdAt: '2025-07-01T22:00:00Z', resolvedAt: '',
  },
  {
    id: 'ALT006', deviceId: 'DEV004', containerId: 'CONT004',
    type: AlertType.GEO_FENCE_BREACH, severity: AlertSeverity.CRITICAL,
    message: '集装箱偏离预定航线：偏离 12海里',
    reading: { timestamp: '2025-07-01T18:00:00Z', temperature: 2.8, humidity: 55, co2: 390, shock: 0.3, lightExposure: 8 },
    acknowledged: true, acknowledgedBy: '张伟', createdAt: '2025-07-01T18:00:00Z', resolvedAt: '2025-07-01T20:00:00Z',
  },
];

const recentOrders: Order[] = [
  { id: 'ORD001', orderNo: 'BP-2025-0001', buyerId: 'BUY001', buyerName: 'FreshFoods Inc.', productName: '智利车厘子', category: '新鲜水果', quantity: 5000, unit: 'kg', unitPrice: 12.5, totalAmount: 62500, currency: 'USD', status: OrderStatus.SHIPPING, createdAt: '2025-06-28T10:00:00Z', updatedAt: '2025-07-02T08:00:00Z', containerIds: ['CONT001'], tradeTerms: 'FOB', originPort: '上海港', destinationPort: '洛杉矶港', specification: 'JJ级', route: '上海 → 洛杉矶', containerMapping: { containerCount: 1, containerNos: ['BLU-C-2601'] }, currentNode: { nodeName: '海运', color: '#43A047' }, currentNodeNumber: 6, paymentMethod: 'T/T', etd: '2025-06-20T00:00:00Z', eta: '2025-07-05T00:00:00Z', displayStatus: OrderDisplayStatus.NORMAL },
  { id: 'ORD002', orderNo: 'BP-2025-0002', buyerId: 'BUY002', buyerName: 'EuroGrocers Ltd.', productName: '厄瓜多尔香蕉', category: '新鲜水果', quantity: 8000, unit: 'kg', unitPrice: 3.2, totalAmount: 25600, currency: 'EUR', status: OrderStatus.CONFIRMED, createdAt: '2025-06-29T14:00:00Z', updatedAt: '2025-07-01T16:00:00Z', containerIds: ['CONT002', 'CONT003'], tradeTerms: 'CIF', originPort: '深圳港', destinationPort: '鹿特丹港', specification: '一级', route: '深圳 → 鹿特丹', containerMapping: { containerCount: 2, containerNos: ['BLU-C-2602', 'BLU-C-2603'] }, currentNode: { nodeName: '包装', color: '#43A047' }, currentNodeNumber: 3, paymentMethod: 'L/C', etd: '2025-06-22T00:00:00Z', eta: '2025-07-10T00:00:00Z', displayStatus: OrderDisplayStatus.NORMAL },
  { id: 'ORD003', orderNo: 'BP-2025-0003', buyerId: 'BUY003', buyerName: 'TokyoFresh Co.', productName: '云南蓝莓', category: '新鲜水果', quantity: 2000, unit: 'kg', unitPrice: 28.0, totalAmount: 56000, currency: 'USD', status: OrderStatus.IMPORT_CUSTOMS, createdAt: '2025-06-25T09:00:00Z', updatedAt: '2025-07-02T06:00:00Z', containerIds: ['CONT004'], tradeTerms: 'DDP', originPort: '青岛港', destinationPort: '釜山港', specification: '14mm+', route: '青岛 → 新加坡', containerMapping: { containerCount: 1, containerNos: ['BLU-C-2604'] }, currentNode: { nodeName: '进口清关', color: '#FB8C00' }, currentNodeNumber: 7, paymentMethod: 'D/P', etd: '2025-06-18T00:00:00Z', eta: '2025-07-02T00:00:00Z', displayStatus: OrderDisplayStatus.NODE_TIMEOUT },
  { id: 'ORD004', orderNo: 'BP-2025-0004', buyerId: 'BUY004', buyerName: 'GlobalSpice LLC', productName: '越南咖啡豆', category: '咖啡豆', quantity: 3000, unit: 'kg', unitPrice: 8.5, totalAmount: 25500, currency: 'USD', status: OrderStatus.DELIVERED, createdAt: '2025-06-20T11:00:00Z', updatedAt: '2025-07-01T12:00:00Z', containerIds: ['CONT005'], tradeTerms: 'FOB', originPort: '宁波港', destinationPort: '汉堡港', specification: 'AA级', route: '宁波 → 鹿特丹', containerMapping: { containerCount: 1, containerNos: ['BLU-C-2605'] }, currentNode: { nodeName: '配送签收', color: '#43A047' }, currentNodeNumber: 10, paymentMethod: 'T/T', etd: '2025-06-12T00:00:00Z', eta: '2025-06-28T00:00:00Z', displayStatus: OrderDisplayStatus.COMPLETED },
  { id: 'ORD005', orderNo: 'BP-2025-0005', buyerId: 'BUY005', buyerName: 'MiddleEast Foods', productName: '新西兰乳制品', category: '乳制品', quantity: 6000, unit: 'kg', unitPrice: 6.8, totalAmount: 40800, currency: 'USD', status: OrderStatus.COMPLETED, createdAt: '2025-06-15T08:00:00Z', updatedAt: '2025-06-30T18:00:00Z', containerIds: ['CONT006'], tradeTerms: 'CFR', originPort: '广州港', destinationPort: '迪拜港', specification: '全脂', route: '青岛 → 迪拜', containerMapping: { containerCount: 1, containerNos: ['BLU-C-2606'] }, currentNode: { nodeName: '配送签收', color: '#43A047' }, currentNodeNumber: 10, paymentMethod: 'L/C', etd: '2025-06-08T00:00:00Z', eta: '2025-06-25T00:00:00Z', displayStatus: OrderDisplayStatus.COMPLETED },
];

export const mockDashboard: DashboardStats = {
  totalOrders: 326,
  activeShipments: 48,
  iotAlerts: 6,
  revenueThisMonth: randomFloat(1800000, 2200000),
  orderTrend: trendPoints,
  shipmentByRoute: routeStats,
  alertTimeline,
  recentOrders,
};
